import React from "react";

import styled from "styled-components";

const AvatarWrapper = styled.div`
  width: 230px;
  height: 230px;
  border-radius: 50%;
  border: 5px solid #f8f8f8;
  overflow: hidden;
  margin: 0;
  z-index: 7;
  background-color: #f8f8f8;

  img {
    width: 100%;
  }
`;
const Avatar = ({ src }) => {
  return (
    <AvatarWrapper>
      <img src={src} alt="logo" />
    </AvatarWrapper>
  );
};

export default Avatar;
